/**
 * Created by anthony on 7/7/14.
 */
var appModel = angular.module('appModel', []);
appModel.factory('AppModelFactory', function(BaseModel, ApplicationService, AbstractModelService){

    var AppModelFactory = function(endpoint){
        BaseModel.apply(this, arguments); 
    }
    AppModelFactory.prototype = new BaseModel();
    AppModelFactory.prototype.parent = BaseModel.prototype;
    AppModelFactory.prototype.getEndpoint = function(applicationID)
    {
        if (typeof this.endpoint == 'undefined')
            this.endpoint = '';
        return "/api/app/" + applicationID + this.endpoint;
    }

    AppModelFactory.prototype.get = function()
    {
        if (typeof this.data == 'undefined')
            this.data = angular.copy(ApplicationService.getAwardData()[this.dataProperty]);
        return ApplicationService.getAwardData()[this.dataProperty];
    }

    AppModelFactory.prototype.set = function(item)
    {
        ApplicationService.getAwardData()[this.dataProperty] = angular.copy(item);
        this.data = angular.copy(item);
    }

    AppModelFactory.prototype.setIndex = function(item, index)
    {
        ApplicationService.getAwardData()[this.dataProperty][index] = angular.copy(item);
    }

    AppModelFactory.prototype.AwardApplicant = function(id, data, instance)
    {
        return AbstractModelService.put(this.getEndpoint(id) + '/AwardApplicant', data, instance);
    }


    return AppModelFactory;
});


appModel.service('AppModelService', function(AppModelFactory){
    var appModel = new AppModelFactory();
    return appModel;
});